import { render, staticRenderFns } from "./EditQa.vue?vue&type=template&id=10bf1426&lang=pug&"
import script from "./EditQa.vue?vue&type=script&lang=js&"
export * from "./EditQa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/qa/editQa.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2Fqa%2FEditQa.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports